/**
 * In-memory glance-once-per-calendar-day (no localStorage).
 * Falls back to once-per-page-load when user id unknown.
 */
const shown = new Set<string>()

function dayKey(d = new Date()): string {
  return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`
}

export function shouldShowGlance(userId?: number | string | null): boolean {
  const key = userId != null ? `u${userId}:${dayKey()}` : `session:${dayKey()}`
  if (shown.has(key)) return false
  shown.add(key)
  return true
}

/** Test helper */
export function resetGlanceShownForTests(): void {
  shown.clear()
}
